import React from 'react'

interface TagsProps {
    tags: string;
    rating?: number
}

const Tags: React.FC<TagsProps> = ({tags, rating}) => {
  return (
    <h6 className='border w-fit text-[13px] px-2 py-1'>{tags}
     {rating && <span> | {rating}/10</span>}
     </h6>
  )
}

export default Tags